import { BaseImage } from './image';
import {Picture} from '@core/services/picture';
import {IVideo} from '@api/models/video/video';

export class PostType {
  static readonly WELCOME  = new PostType('WELCOME', 'welcome');
  static readonly FH_START  = new PostType('FH_START', 'fh_start');
  static readonly FH_END  = new PostType('FH_END', 'fh_end');
  static readonly SH_START  = new PostType('SH_START', 'sh_start');
  static readonly SH_END  = new PostType('SH_END', 'sh_end');
  static readonly LINEUP  = new PostType('LINEUP', 'lineup');
  static readonly UNKNOWN  = new PostType('UNKNOWN', 'unknown');

  static readonly types: PostType[] = [
    PostType.WELCOME,
    PostType.FH_START,
    PostType.FH_END,
    PostType.SH_START,
    PostType.SH_END,
    PostType.LINEUP,
  ];

  static fromValue(value: string): PostType {
    for (let i = 0; i < this.types.length; i++) {
      if (this.types[i].value === value) {
        return this.types[i];
      }
    }

    return PostType.UNKNOWN;
  }

  // private to disallow creating other instances of this type
  private constructor(
    private readonly key: string,
    public readonly value: any,
  ) {}
}

export class Post {
  _id: string;
  _created: number;
  relative_timestamp: number;
  timestamp: number;

  activation: number;
  activation_milliseconds: number;
  activation_relative_to: string;

  title: string;
  text: string;
  symbol: string;
  type: string;
  typeAsObj: PostType;
  display_minute: string;
  images: BaseImage[];
  teamid: string;

  playerImage: Picture[] = [];
  otherImages: Picture[] = [];
  videos_native: IVideo[];


  public constructor(init?: Partial<Post>) {
    Object.assign(this, init);
    this.images = [];
    this.typeAsObj = PostType.fromValue(init.type);
  }

  getPlayerImage(): Picture {
    if (this.playerImage.length !== 0 && this.playerImage[0] != null) {
      return this.playerImage[0];
    }
    return null;
  }
}
